import React, { Component } from "react";
import { WPStatusModalContainer } from './wp-status-modal-style'
import { images } from "../../../../assets";
import { wpStatusDataColumns } from "../../../../constants/clientsPolicies";
import MainTable from "../../../../components/main-table";

interface IWPStatusModalProps {
  close: () => void;
  wpStatus: any[];
}

interface IWPStatusModalState {
  
}

class WPStatusModal extends Component<
  IWPStatusModalProps,
  IWPStatusModalState
> {

  constructor(props: IWPStatusModalProps) {
    super(props);
  }

  render() {
    const { close, wpStatus } = this.props;
    return (
      <WPStatusModalContainer>
        <div
          className="wp-status-modal-container"
        >
          <div className="wp-status-modal-container-close">
            <img src={images.IconCloseGrey} onClick={() => close()} />
          </div>
          <div className="wp-status-modal-container-table">
            <MainTable
              className="table topMargin15"
              columns={wpStatusDataColumns}
              rows={wpStatus}
              keysRow={["service", "state", "description", "date"]}
            />
          </div>
        </div>
      </WPStatusModalContainer>
    );
  }
}

export default WPStatusModal;
